export default {
      id: "ic_game_info-usage",
      viewBox: "0 0 24 24",
      url: "/" + "images/icons.3.109.2.svg#ic_game_info-usage",
      toString: function () {
        return this.url;
      }
    }